import clsx from "clsx";
import { ShapeProps } from "./types";
import HexagonIcon from "@mixitone/icons/hexagon.svg";

export const Hexagon: React.FC<ShapeProps> = ({ color, size, className, style, children }) => {
  return (
    <div
      className={clsx("relative flex items-center justify-center", className)}
      aria-roledescription="color dot"
      style={{
        width: `${size}px`,
        height: `${size}px`,
        ...style,
      }}
    >
      <HexagonIcon className="absolute inset-0" width={size} height={size} style={{ fill: color }} />
      <span className="relative font-bold">{children}</span>
    </div>
  );
};
